import { useDisclosure } from "@kirvanobr/use-disclosure";
import { useGetCompanies } from "@queries/companies";
import { useGetIPv6 } from "@queries/user";
import { createContext, useMemo, useState } from "react";

import { SettingsContextData, SettingsProviderProps } from "./SettingsContext.types";

export const SettingsContext = createContext({} as SettingsContextData);

export function SettingsProvider({ user, children }: SettingsProviderProps) {
  const { companies } = useGetCompanies({});

  const [isCompanyModalOpen, setCompanyModalOpen] = useState<boolean>(false);
  const [isProfileModalOpen, setProfileModalOpen] = useState<boolean>(false);
  const [isEmailContactUpdating, setEmailContactUpdating] = useState<boolean>(false);
  const [isPhoneContactUpdating, setPhoneContactUpdating] = useState<boolean>(false);

  const { isOpen: isCompanyMobileOpen, onOpenChange: onCompanyMobileOpenChange } = useDisclosure();
  const { isOpen: isProfileMobileOpen, onOpenChange: onProfileMobileOpenChange } = useDisclosure();
  const { isOpen: isPasswordMobileOpen, onOpenChange: onPasswordMobileOpenChange } = useDisclosure();

  const { isOpen: isOpenProfileMobileModal, onOpenChange: onOpenChangeProfileMobileModal } = useDisclosure();

  const { data } = useGetIPv6();

  const onboardingStep1 = useMemo(() => !user?.isUpdated, [user]);
  const onboardingStep2 = useMemo(
    () => !onboardingStep1 && !(companies && companies.length),
    [onboardingStep1, companies]
  );

  const isOnboarding = useMemo(() => onboardingStep1 || onboardingStep2, [onboardingStep1, onboardingStep2]);

  return (
    <SettingsContext.Provider
      value={{
        isOnboarding,
        onboardingStep1,
        onboardingStep2,
        isCompanyModalOpen,
        setCompanyModalOpen,
        isProfileModalOpen,
        setProfileModalOpen,
        isEmailContactUpdating,
        setEmailContactUpdating,
        isPhoneContactUpdating,
        setPhoneContactUpdating,
        isCompanyMobileOpen,
        onCompanyMobileOpenChange,
        isProfileMobileOpen,
        onProfileMobileOpenChange,
        isPasswordMobileOpen,
        onPasswordMobileOpenChange,
        isOpenProfileMobileModal,
        onOpenChangeProfileMobileModal,
        ipv6: data,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}
